import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import styles from '../../TransferPage.module.scss';
import Label from '../../../../constants/Label';
const Menu = () => {
  let location = useLocation();
  return (
    <div className={styles.pageLeft__stepper}>
      <span></span>
      <div className={styles.pageLeft__item + ' ' + `${location.state && location.state.menu.beneficiary == true ? styles.active : ''}`}>
        <span></span>
        {Label.Menu.Beneficiary}
      </div>
      <div className={styles.pageLeft__item + ' ' + `${location.state && location.state.menu.amount == true ? styles.active : ''}`}>
        <span></span>
        {Label.Menu.Amount}
      </div>
      <div className={styles.pageLeft__item + ' ' + `${location.state && location.state.menu.payment == true ? styles.active : ''}`}>
        <span></span>
        {Label.Menu.Payment}
      </div>
      <div className={styles.pageLeft__item + ' ' + `${location.state && location.state.menu.confirm == true ? styles.active : ''}`}>
        <span></span>
        {Label.Menu.Confirm}
      </div>
      <div className={styles.pageLeft__item + ' ' + `${location.state && location.state.menu.transfer == true ? styles.active : ''}`}>
        <span></span>
        {Label.Menu.Transfer}
      </div>
    </div>
  );
};

export default Menu;
